import {
  Button,
  Inline,
  Modal,
  type ModalProps,
  notifySuccess,
  useModal,
} from '@omnipresentgroup/design-system';
import { useDeleteClientPolicyMutation } from '@omnipresentgroup/domains';
import type { ClientPolicyCountry } from '@omnipresentgroup/types';
import { useEffect, useState } from 'react';

import { LeaveSettingsCutOffDayNotification } from './LeaveSettingsCutOffDayNotification';

const MODAL_TITLE = 'Activate statutory policy?';
const SUCCESS_MESSAGE = 'Statutory policy has been activated successfully';
const ACTIVATE_TEXT = 'Activate';
const CANCEL_TEXT = 'Cancel';

type StatutoryActivationModalProps = {
  companyId: string;
  country: ClientPolicyCountry;
  trigger: ModalProps['trigger'];
};

export const StatutoryActivationModal = ({
  companyId,
  country,
  trigger,
}: StatutoryActivationModalProps) => {
  const { modalProps, isOpen } = useModal({ trigger });

  const [modalOpen, setModalOpen] = useState(false);

  const {
    mutate: deleteCustomPolicy,
    isSuccess: isDeletionSuccess,
    isPending: isDeleting,
    reset: resetDeletion,
  } = useDeleteClientPolicyMutation();

  useEffect(() => {
    if (isDeletionSuccess) {
      notifySuccess({ title: SUCCESS_MESSAGE });
      resetDeletion();
      setModalOpen(false);
    }
  }, [isDeletionSuccess, resetDeletion]);

  return (
    <Modal
      {...modalProps}
      span={2}
      open={isOpen || modalOpen}
      onOpenChange={setModalOpen}
    >
      <Modal.Header title={MODAL_TITLE} description={`In ${country.name}`} />
      <Modal.Body>
        <LeaveSettingsCutOffDayNotification />
      </Modal.Body>
      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button
            variant="secondary"
            onClick={() => setModalOpen(false)}
            disabled={isDeleting}
          >
            {CANCEL_TEXT}
          </Button>
          <Button
            loading={isDeleting}
            onClick={() =>
              deleteCustomPolicy({
                clientId: companyId,
                countryCode: country.code,
              })
            }
          >
            {ACTIVATE_TEXT}
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
